import { type RowData, type TableOptions, useReactTable } from '@tanstack/react-table'

type DataTableOptions<TData extends RowData> = Omit<
  TableOptions<TData>,
  'autoResetAll' | 'autoResetPageIndex' | 'autoResetExpanded'
>

/**
 * The only way to build a table in this repo; Biome bans `useReactTable` elsewhere.
 *
 * TanStack resets the page index (and the expanded rows) whenever `data`
 * changes identity, and that reset re-renders the table's owner. An owner that
 * builds `data` during render (`lines.map(...)`, `query.data ?? []`) hands over
 * a new array each time, so the reset fires again, without end. After a click
 * React renders each round at once, and the page freezes. No table here pages
 * or expands on the client, so the resets are switched off for good, not left
 * as an option a screen could turn back on.
 */
export function useDataTable<TData extends RowData>(options: DataTableOptions<TData>) {
  return useReactTable({ ...options, autoResetPageIndex: false, autoResetExpanded: false })
}
